export const fn =
  (order, active = false, originalIndex = 0, currIndex = 0, y = 0) =>
  index =>
    active && index === originalIndex
      ? {
          y: currIndex * 40 + y,
          scale: 1.1,
          zIndex: 1,
          shadow: 15,
          immediate: key => key === 'y' || key === 'zIndex',
        }
      : {
          y: order.indexOf(index) * 40,
          scale: 1,
          zIndex: 0,
          shadow: 1,
          immediate: false,
        };

export const swap = (array, moveIndex, toIndex) => {
  const item = array[moveIndex];
  const length = array.length;
  const diff = moveIndex - toIndex;

  if (diff > 0) {
    // move left
    return [
      ...array.slice(0, toIndex),
      item,
      ...array.slice(toIndex, moveIndex),
      ...array.slice(moveIndex + 1, length),
    ];
  } else if (diff < 0) {
    // move right
    const targetIndex = toIndex + 1;
    return [
      ...array.slice(0, moveIndex),
      ...array.slice(moveIndex + 1, targetIndex),
      item,
      ...array.slice(targetIndex, length),
    ];
  }
  return array;
};
